<template>
  <div>
    <div class="filter-label">
      Cycle Type
    </div>
    <div class="filter-options">
      <SACCheckbox
        label="Cooling"
        field="cycleType"
        :checked="existingCycleTypes.includes('cool')"
        :change="() => handleSystemFilters(
          'cycleTypeFilter',
          'cool',
          !!existingCycleTypes.includes('cool'))"
      />
      <SACCheckbox
        label="Heating"
        field="cycleType"
        :checked="existingCycleTypes.includes('heat')"
        :change="() => handleSystemFilters(
          'cycleTypeFilter',
          'heat',
          !!existingCycleTypes.includes('heat'))"
      />
      <SACCheckbox
        label="Fan"
        field="cycleType"
        :checked="existingCycleTypes.includes('fan')"
        :change="() => handleSystemFilters(
          'cycleTypeFilter',
          'fan',
          !!existingCycleTypes.includes('fan'))"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SACCheckbox from '../../sac/SACCheckbox.vue';

export default {
  name: 'CycleTypeFilter',
  components: {
    SACCheckbox,
  },
  computed: {
    ...mapState({
      existingCycleTypes: state => state.customerDetail.systemFilter.cycleTypeFilter,
    }),
  },
  methods: {
    handleSystemFilters(field, value, checked) {
      this.$store.dispatch('setDetailSystemFilter', {
        field,
        value,
        checked,
      });
    },
  },
};
</script>

<style scoped>

</style>
